import { ContentModuleType } from '@tribeplatform/gql-client/types'
import { useActiveContentModule } from '@tribeplatform/react-components/common/hooks'
import { EventDetailsModal } from '@tribeplatform/react-components/Event'
import { useEventModuleAvailability } from '@tribeplatform/react-components/Event/hooks'

export const ContentModuleModalRenderer = () => {
  const { contentType, contentId, clearActiveContentModule } =
    useActiveContentModule()
  const { isEventModuleEnabledOnNetwork } = useEventModuleAvailability()

  if (!contentType || !contentId) {
    return null
  }

  switch (contentType) {
    case ContentModuleType.event:
      if (!isEventModuleEnabledOnNetwork) {
        return null
      }
      return (
        <EventDetailsModal
          open
          eventId={contentId}
          onClose={clearActiveContentModule}
        />
      )
    default: {
      const _exhaustiveCheck: never = contentType
      return _exhaustiveCheck
    }
  }
}
